module.exports = __webpack_public_path__ + "img/add-debit-card.ef120c51.png";